import { Device } from 'types';

// Picked colors from: https://material.io/archive/guidelines/style/color.html#color-color-palette
/** Light green */
export const connectedColor = '#A5D6A7';
/** Light red */
export const disconnectedColor = '#EF9A9A';
/** Light purple */
export const shippedColor = '#9FA8DA';
/** Teal blue */
export const deployedColor = '#80DEEA';
/** Light yellow */
export const returnedColor = '#FFE082';
/** Light orange */
export const returnedArrivedColor = '#FEC8BD';
/** Gray */
export const retiredColor = '#9E9E9E';
/** Blue gray */
export const sleepColor = '#B0BEC5';
/** Orange */
export const undeployedColor = '#FFCC80';

/** Returns a hex code of a color representing the inputted device's status. */
export const getDeviceStatusColor = function (status: string) {
    if (!status) return '';

    const colors: { [status: string]: string } = {
        shipped: shippedColor,
        deployed: deployedColor,
        returned: returnedColor,
        retired: retiredColor,
        sleep: sleepColor,
        'return-arrived': returnedArrivedColor,
    };

    return colors[status.toLowerCase()];
};

/** Return a boolean as to whether the inputted device status should be displayed to the customer. */
export function isCustomerFacing(status: string): boolean {
    const customerFacingStatuses = ['deployed', 'shipped', 'sleep'];
    return customerFacingStatuses.includes(status.toLowerCase());
}

/** Return the name of the next step based on current device status. */
export const getNextSteps = function (status: string) {
    const statusToAction: { [status: string]: string } = {
        retired: 'Return',
        shipped: 'Deploy',
        sleep: 'Redeploy',
        deployed: 'N/A',
    };

    return statusToAction[status.toLowerCase()];
};

/** Set the device isConnected field and return that value. */
export const isDeviceConnected = (device: Device): boolean => {
    const now = new Date().getTime();
    const lr = device.lastReading;
    // Only deployed devices should have an lr value.
    if (lr && lr.time) {
        const oneDayInMilliSeconds = 86400000;
        if (now - lr.time > oneDayInMilliSeconds * 3) {
            device.isConnected = false;
        } else {
            device.isConnected = true;
        }
    } else if (device.virtual || device.connection_type === 'virtual') {
        device.isConnected = false;
    } else {
        // Undeployed devices are not connected.
        return (device.isConnected = false);
    }
    return device.isConnected;
};
